import React, { useLayoutEffect, useRef } from "react";

// One line of text that shrinks (down to `min` × its CSS size) instead of being cut off.
export const FitText = ({ as: Tag = "span", className = "", min = 0.7, children, ...rest }) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el) return undefined;
        const fit = () => {
            el.style.fontSize = "";
            const sw = el.scrollWidth, cw = el.clientWidth;
            if (sw <= cw + 0.5 || !cw) return;
            const base = parseFloat(getComputedStyle(el).fontSize) || 12;
            el.style.fontSize = `${base * Math.max(min, (cw / sw) * 0.98)}px`;
        };
        fit();
        let lastW = (el.parentElement || el).clientWidth;
        const ro = new ResizeObserver(() => { const w = (el.parentElement || el).clientWidth; if (w !== lastW) { lastW = w; fit(); } });
        ro.observe(el.parentElement || el);
        return () => ro.disconnect();
    }, [children, min]);
    return <Tag ref={ref} className={`block whitespace-nowrap overflow-hidden text-ellipsis ${className}`} {...rest}>{children}</Tag>;
};
